




























































































import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class ProductOptionAddForm extends Vue {
  @Prop({default: false}) private optionGuide!: boolean;
}
